import { useOverflow } from "@/hooks/useOverflow"
import { DarkButton } from "@/ui/Button"
import { Chip } from "@/ui/Chip"
import { ListFilter } from "@/ui/icons/ListFilter"
import { Triangle } from "@/ui/icons/Triangle"
import { cn, } from "@heroui/react"
import { motion } from "framer-motion"
import { useRef, useState } from "react"

export default ({ children, className, ...other }: any) => {

  const container = useRef<HTMLDivElement>(null)

  const { overflowX } = useOverflow(container)

  const [isExpand, setIsExpand] = useState(false)

  return (<div ref={container} className={cn(
    "relative flex w-full justify-start gap-[6px] ",
    isExpand ? 'flex-wrap ' : ' h-[26px] p-[1px] pr-[84px] overflow-hidden ',
    className)
  }  {...other}>
    <motion.div animate={(!isExpand && overflowX) ? 'open' : 'close'}
      initial={false}
      variants={{
        open: {
          width: 95,
          paddingLeft: 10
        },
        close: {
          width: 0,
          paddingLeft: 0
        }
      }}
      className="pl-[10px] absolute right-0 top-0 z-10 bg-surface overflow-hidden h-[26px]" >
      <Chip
        className="text-red flex items-center text-nowrap gap-[8px] cursor-pointer !text-white bg-btn-primary hover:bg-btn-primary/85"
        setSelectValue={() => { setIsExpand(!isExpand) }}>
        <ListFilter />
        All Tags
      </Chip>
    </motion.div>
    {children}
    {
      isExpand &&
      < DarkButton
        isIconOnly
        className="w-[24px] h-[24px] min-w-0 items-center"
        onPress={() => setIsExpand(false)}
      >
        <Triangle className="rotate-180" />
      </DarkButton>
    }


  </div >)
}